/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { useState } from "react"
import Button from "../../UI/Button/Button"
import { ProgressState } from "../../UI/Button/buttonTypes"
import { useUserCreateError } from "../userHooks"
import ContactInfoEditor from "./ContactInfo"
import SaveIcon from "@material-ui/icons/SaveRounded"
import { Theme } from "../../types"
import { useUserDispatch, useUserState } from "../../../context/UserContext"
import { useParams } from "react-router-dom"
import { useDiscountDispatch } from "../../../context/DiscountContext"
import { useUserOps } from "../operations"
import { useNavigateToCreated } from "../../hooks"
import { Snackbar } from "@material-ui/core"
import { Alert } from "@material-ui/lab"

// TODO probably should align duplicate code in here and in the Editor
export default function UserCreator() {
    const { name: organization } = useParams<{
        name: string
        userId: string
    }>()
    const [alreadyRegistered, setAlreadyRegistered] = useState(false)
    const [saveProgress, setSaveProgress] = useState<ProgressState>("ideal")
    const [missingCompanyName, setMissingCompanyName] = useState(false)
    const {
        error: saveError,
        deriveError: deriveSaveError,
        clearError: clearSaveError,
    } = useUserCreateError()
    const userState = useUserState()
    const dispatch = useUserDispatch()
    const discountsDispatch = useDiscountDispatch()
    const { createUser } = useUserOps()
    const { navigateTo } = useNavigateToCreated()
    const [invalidSalesEmail, setInvalidSalesEmail] = useState(false)

    const handleChange = () => {
        setSaveProgress("ideal")
    }

    const handleSaveClick = async () => {
        if (
            userState.salesContactEmail &&
            !userState.salesContactEmail.includes("@")
        ) {
            setInvalidSalesEmail(true)
            return
        }
        if (userState.companyName) {
            await serviceCall()
            setMissingCompanyName(false)
        } else {
            setMissingCompanyName(true)
        }
    }

    const handleErrorClose = () => {
        setSaveProgress("ideal")
        clearSaveError()
    }

    const serviceCall = async () => {
        if (organization !== null && userState.email !== undefined) {
            setSaveProgress("loading")
            createUser(
                { ...userState },
                {
                    onSuccess(newUser) {
                        dispatch({
                            type: "LOAD_USER_INFO",
                            payload: {
                                ...userState,
                                ...newUser.data,
                            },
                        })
                        cleanUpStates()
                        navigateTo(newUser.id)
                    },
                    onSettled(newUser) {
                        if (newUser) {
                            setAlreadyRegistered(
                                newUser.data?.auth0UserId !== undefined
                            )
                        }
                    },
                    onError: (err) => {
                        deriveSaveError(err)
                        setSaveProgress("error")
                    },
                }
            )
        } else {
            alert("Missing organization or email! Could not create user!")
        }
    }

    // TODO probalby this is live in the context provider
    const cleanUpStates = () => {
        setSaveProgress("success")
        dispatch({
            type: "SET_HAS_CHANGED",
            payload: false,
        })
        discountsDispatch({
            type: "SET_HAS_CHANGED",
            payload: false,
        })
    }

    return (
        <div>
            <ContactInfoEditor
                isRegistered={alreadyRegistered ?? false}
                error={saveError}
                onAttributeChange={handleChange}
                missingRequiredField={missingCompanyName}
                invalidSalesEmail={invalidSalesEmail}
            />
            <Button
                variant="contained"
                color="primary"
                onClick={handleSaveClick}
                progress={saveProgress}
                size="large"
                startIcon={<SaveIcon />}
                css={styles.saveBtn}
                testId="button_save"
            >
                Mentés
            </Button>
            <Snackbar
                open={saveProgress === "error"}
                autoHideDuration={6000}
                onClose={handleErrorClose}
            >
                <Alert
                    severity="error"
                    elevation={6}
                    variant="filled"
                    onClose={handleErrorClose}
                >
                    {saveError?.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

const styles = {
    saveBtn: (theme: Theme) => css`
        margin-top: ${theme.spaces.smallScale.l};
    `,
}
